import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import ChannelVisibilityContainer from 'containers/dashboards/siteDirect/ChannelVisibilityContainer';
import GenericSiteDirectExpandContainer from 'containers/dashboards/siteDirect/GenericSiteDirectExpandContainer';
import { generateCalloutComponents } from 'helpers/componentGenerators';
import { getActivitiesSettings } from 'helpers/objectiveSettings';

class VideoModule extends Component {
    render() {
        const { channel, ioChannel } = this.props;
        const stub = 'l3-site-video';
        const { entityObjective } = this.props;
        const {
            eCPAActivitiesOrClicks, calloutTitle
        } = getActivitiesSettings(entityObjective);

        const hasCalloutData = get(this.props, 'channel.callouts.params.hasData', false);
        const callouts = get(this.props, 'channel.callouts.data', {});
        const calloutWindow = get(this.props, 'channel.callouts.params.timeRanges.previous.windowSize', null);

        const calloutSettings = [
            { key: 'completed_plays', title: 'Completed Views', format: '0,0' },
            { key: eCPAActivitiesOrClicks, title: calloutTitle, format: '0,0' },
            { key: 'completion_rate', title: 'Completion Rate', format: '0.00%' },
            { key: 'cpcv', title: 'CPCV', format: '$0,0.00' },
        ];

        const calloutComponents = generateCalloutComponents({
            stub, calloutSettings, hasCalloutData, callouts, calloutWindow
        });

        return (
            <ChannelVisibilityContainer ioChannel={ioChannel} channel={channel}
                expandContainer={GenericSiteDirectExpandContainer}>
                {/* Call Outs */}
                <Row>
                    {calloutComponents}
                </Row>


            </ChannelVisibilityContainer>
        );
    }
}

VideoModule.propTypes = {
    channel: PropTypes.object,
    ioChannel: PropTypes.string
};


export default VideoModule;



// WEBPACK FOOTER //
// ./src/components/organisms/siteDirect/VideoModule.js